import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { ConfirmButton } from 'components/ui/Button';
import DiscountEditReasonSelect from './DiscountEditReasonSelect';
import { ButtonWrapper, StyledTextarea } from './DiscountUpdateModalReasons.styles';

const DiscountUpdateModalReasons = ({ isLoading, onToggle, onSubmit, showUpdateWarnings, isOpen = false }) => {
  const { register, handleSubmit, formState, control } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      reason: ''
    }
  });

  const onSubmitFormat = async ({ reason, reasonOption }) => {
    onSubmit({ reason: `${reasonOption}: ${reason}` });
  };

  return (
    <Modal isOpen={isOpen} title={<FormattedMessage id="vouchers.updateConfirmationTitle" />} onClose={onToggle}>
      <form onSubmit={handleSubmit(onSubmitFormat)} data-cy="voucher-update-confirmation-form">
        <ul>
          {showUpdateWarnings && (
            <>
              <li>
                <FormattedMessage id="vouchers.updateConfirmationParagraph1" />
              </li>
            </>
          )}
          <li>
            <FormattedMessage id="vouchers.supplyReason" />
          </li>
        </ul>
        <DiscountEditReasonSelect control={control} />
        <StyledTextarea
          name="reason"
          required
          rows="3"
          cols="40"
          data-cy="reason"
          {...register('reason', {
            required: true,
            min: 1
          })}
        />

        <ButtonWrapper>
          <ConfirmButton
            type="submit"
            data-cy="submit"
            data-testid="submit"
            loading={isLoading}
            disabled={isLoading || !formState.isValid}
            variant="primary"
          >
            <FormattedMessage id="vouchers.confirm" />
          </ConfirmButton>
        </ButtonWrapper>
      </form>
    </Modal>
  );
};

DiscountUpdateModalReasons.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onToggle: PropTypes.func,
  onSubmit: PropTypes.func,
  showUpdateWarnings: PropTypes.bool
};

export default DiscountUpdateModalReasons;
